import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import ArticuloMonedaGestion from './view/ArticuloMonedaGestion'

// No se requiere administración de monedas de sistema, la habilitación aplica a modulo
export const articuloMonedaRoutesMap = {
  gestion: {
    path: '/articuloMoneda/gestion',
    name: 'Monedas de Sistema',
    action: 'MONEDAS_DE_SISTEMA',
  },
  registro: {
    path: '/articuloMoneda/nuevo',
    name: 'Nuevo Articulo Moneda',
    action: 'NUEVO_ARTICULO_MONEDA',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloMonedaRoutes = [
  {
    path: articuloMonedaRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloMonedaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: articuloMonedaRoutesMap.upsert.path,
    element: <Articulo MonedaRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default articuloMonedaRoutes
